import { render, staticRenderFns } from "./UserManagementPage.vue?vue&type=template&id=5379028c&scoped=true&"
import script from "./UserManagementPage.vue?vue&type=script&lang=js&"
export * from "./UserManagementPage.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementPage.vue?vue&type=style&index=0&id=5379028c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5379028c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5379028c')) {
      api.createRecord('5379028c', component.options)
    } else {
      api.reload('5379028c', component.options)
    }
    module.hot.accept("./UserManagementPage.vue?vue&type=template&id=5379028c&scoped=true&", function () {
      api.rerender('5379028c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/UserManagementPage.vue"
export default component.exports